module.exports = __webpack_public_path__ + "static/media/bern1.d2f7169d.jpg";